module.exports = __webpack_public_path__ + "static/media/heart_fine.62e8ea9e.svg";